export default __webpack_public_path__ + "static/media/Portugal.ca0cd70d.svg";